import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import at from 'lodash/at'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import Select from 'react-select'

import {
  loadAreasByLocation,
  searchAreasByLocation,
  setCurrentSearch,
  resetCurrentFilter
} from '../../actions/areas'

import { getAreasBySearch } from '../../selectors/area-selectors'

function mapStateToProps (state, ownProps) {
  const areas = getAreasBySearch(state, ownProps)

  const options = areas.map(area => ({
    value: area.id,
    label: area.name
  }))

  options.unshift({
    value: null,
    label: 'All'
  })

  return { options }
}

function mapDispatchToProps (dispatch, ownProps) {
  const locationId = ownProps.locationId
  let params = {
    locationId,
    searchQuery: '',
    nextPage: false
  }

  const throttledSearch = throttle(
    () => dispatch(
      searchAreasByLocation(params)
    ), 250
  )

  return {
    onMenuScrollToBottom () {
      dispatch(searchAreasByLocation({
        ...params,
        nextPage: true
      }))
    },

    onInputChange (search) {
      params.searchQuery = search

      dispatch(setCurrentSearch(search))
        .then(() => throttledSearch())
    },

    resetSearch () {
      dispatch(setCurrentSearch(''))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)




// WEBPACK FOOTER //
// ./src/containers/inspections/select-area-container.js